export const SET_SESSION = 'SET_SESSION'
export const LOGOUT = 'LOGOUT'
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_PROGRAM = 'SET_PROGRAM';
export const CLEAR_PROGRAM = 'CLEAR_PROGRAM';
